export default {
  start: "start",
  matched: "matched",
  matchedConfirmUsers: "matchedConfirmUsers",
  canceled: "canceled",
  inProgress: "inProgress",
  completed: "completed",
};
